export enum Languages {
  'CL',
  'MX',
}

export type Language = Languages;
